import * as PIXI from "pixi.js";
import Game from "../../../../../../../src/Game";
import Line from "../../../../../../../src/entities/Line/Line";
import Point from "../../../../../../../src/entities/Point";
import PencilLine from "../../../../../../../src/entities/PencilLine";
import { Coord } from "../../../../../../../src/types/Interface";
import { DrawingTool } from "../../../types/Enum";
import { getLineType, getPointColor } from "./helpers/DrawingHelpers";
import { DrawingType } from "../../../types/Type";


export default class DrawingManagerRendererFactory {
  static destroyDrawing = (d: DrawingType) => {
    d && d.parent?.removeChild(d);
    d && d.destroy();
  };
  static createPoint(tool: DrawingTool, coord: Coord, color: number): Point {
    const point = new Point(coord, color, 15, false);
    point.draw(coord);
    return point;
  }
  static createPencilLine(lineColor: number): PencilLine {
    const width = 5;
    return new PencilLine({ width, lineColor });
  }
  static createLine(color: number, tool?: DrawingTool): Line {
    const l = new Line(getLineType(tool, color))
    l.setVisibleOfEqualSymbol(true);
    return l;
  }
  static drawBg(bg: PIXI.Graphics) {
    const dim = Game.getInstance().getDim();
    bg
      .clear()
      .moveTo(0, 0)
      .rect(0, 0, dim.WIDTH, dim.HEIGHT)
      .fill({ color: 0xff0000, alpha: 0 });
  }
}